import { render, staticRenderFns } from "./BirthCertificate.vue?vue&type=template&id=bb7c67d8&"
import script from "./BirthCertificate.vue?vue&type=script&lang=js&"
export * from "./BirthCertificate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports